<template>
  <div v-if="!item.hidden">
    <!-- 只有一个子路由时直接显示 -->
    <template v-if="hasOneShowingChild(item.children, item) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow">
      <el-menu-item :index="resolvePath(onlyOneChild.path)" @click="handleMenuClick(resolvePath(onlyOneChild.path))">
        <i v-if="onlyOneChild.meta && onlyOneChild.meta.icon" :class="onlyOneChild.meta.icon" />
        <span slot="title">{{ onlyOneChild.meta && onlyOneChild.meta.title }}</span>
      </el-menu-item>
    </template>

    <!-- 有多个子路由时显示子菜单 -->
    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)">
      <template slot="title">
        <i v-if="item.meta && item.meta.icon" :class="item.meta.icon" />
        <span>{{ item.meta && item.meta.title }}</span>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :item="child"
        :base-path="resolvePath(item.path)"
      />
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    item: { type: Object, required: true },
    basePath: { type: String, default: '' }
  },
  data() {
    return { onlyOneChild: null }
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) return false
        this.onlyOneChild = item
        return true
      })
      if (showingChildren.length === 1) return true
      if (showingChildren.length === 0) {
        // 不覆盖 path 为空字符串：保留 parent 自身的路径，
        // 否则 resolvePath('') 会返回 basePath（父路径），导致所有叶子菜单
        // 都跳转到同一个父路由（如 /system → 重定向到 /system/user）
        this.onlyOneChild = { ...parent, noShowingChildren: true }
        return true
      }
      return false
    },
    resolvePath(routePath) {
      if (!routePath) return this.basePath
      if (/^(https?:|mailto:|tel:)/.test(routePath)) return routePath
      if (routePath.startsWith('/')) return routePath
      const base = this.basePath.endsWith('/') ? this.basePath : this.basePath + '/'
      return base + routePath
    },
    handleMenuClick(targetPath) {
      this.$router.push(targetPath)
    }
  }
}
</script>
